import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-subscribe-options.tsx
var LazyCourseSubscribeOptions = lazy(() => import("./course-subscribe-options-DtHGYKkq.js").then((n) => n.n).then((module) => ({ default: module.CourseSubscribeOptions })));
function CourseSubscribeOptions({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-goals" }),
		children: /* @__PURE__ */ jsx(LazyCourseSubscribeOptions, { ...props })
	});
}
function CourseSubscribeOptionsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-goals" }),
		children: /* @__PURE__ */ jsx(LazyCourseSubscribeOptions, { ...props })
	});
}
var useCourseSubscribeOptionsContent = () => {
	return useMemo(() => ({ courseSubscribeOptions: { component: CourseSubscribeOptionsContent } }), []);
};
//#endregion
export { CourseSubscribeOptions, useCourseSubscribeOptionsContent };
